import React from 'react';
import {Switch} from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import HealthcareFacilityLevel from './healthcare-facility-level';
import HealthcareFacilityLevelDetail from './healthcare-facility-level-detail';
import HealthcareFacilityLevelUpdate from './healthcare-facility-level-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={HealthcareFacilityLevelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:countryId/:level/edit`} component={HealthcareFacilityLevelUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:countryId/:level`} component={HealthcareFacilityLevelDetail} />
      <ErrorBoundaryRoute path={match.url} component={HealthcareFacilityLevel} />
    </Switch>
  </>
);

export default Routes;
